<template lang="pug">
    md-content#login-form.center-panel.md-elevation-1(md-theme="white")

        div(v-if="message")
            md-content.md-elevation-1.md-accent.message {{message}}
        div(v-if="!message")
            md-content.md-elevation-1.md-accent.message Укажите свой Логин в системе, мы отправим ссылку для восстановления на вашу почту.
            form(@submit.prevent="submit")
                md-field
                    label Логин
                    md-input(v-model="login")

                .md-layout.md-gutter.md-alignment-center-right
                    .md-layout-item.md-size-50
                        md-button.md-raised.md-primary(type="submit") Отправить
                    .md-layout-item.md-size-50
                        router-link(v-bind:to="{name: 'Login'}") Авторизоваться
</template>
<script>
    export default {
        data() {
            return {
                login: '',
                message: ''
            }
        },
        metaInfo() {
            return {
                title: 'Восстановление пароля'
            }
        },
        created() {
            //устанавливаем небольшой размер центральной панели
            this.$store.commit('setSmallSizePanel')
        },
        methods: {
            submit() {
                this.error = false;
                this.$store.dispatch('users/resetPassword', this.login).then(r => {
                    if (r) this.message = 'Email отправлен, проверьте свою почту.';
                });
            }
        }
    }
</script>

<style lang="sass">
    #login-form
        height: auto
        width: 400px
        margin: auto
</style>


// WEBPACK FOOTER //
// ResetPassword.vue?694c53e2